
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ImportDemoDataResponse_$reflection } from "../../Shared/Onboarding.js";
import { FormState__startLoading, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { record_type, lambda_type, unit_type, union_type, class_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_errorToast, Cmd_successToast } from "../../Components/Toast.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_importDemoData } from "../../Requests/Onboarding.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { TextValue } from "../../Components/Text.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ImportData", "DataImported", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Widgets.Dialogs.DemoDataImportDialog.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(ImportDemoDataResponse_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(FormState, OnClose, SuccessCallback) {
        super();
        this.FormState = FormState;
        this.OnClose = OnClose;
        this.SuccessCallback = SuccessCallback;
    }
}

export function State_$reflection() {
    return record_type("Widgets.Dialogs.DemoDataImportDialog.State", [], State, () => [["FormState", FormState_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)], ["SuccessCallback", lambda_type(unit_type, unit_type)]]);
}

function init(successCallback, onClose) {
    return [new State(FormState_get_empty(), onClose, successCallback), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response = msg.fields[0];
            let matchResult;
            if (response.tag === 1) {
                matchResult = 1;
            }
            else if (response.fields[0].tag === 1) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return [new State(FormState_get_empty(), state.OnClose, state.SuccessCallback), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                        state.SuccessCallback();
                    }), Cmd_ofEffect((_arg_1) => {
                        state.OnClose();
                    }), Cmd_successToast("general.saved_successfully")]))];
                default:
                    return [new State(FormState_get_empty(), state.OnClose, state.SuccessCallback), Cmd_errorToast("general.a_error_occured")];
            }
        }
        case 2:
            return [new State(FormState_get_empty(), state.OnClose, state.SuccessCallback), Cmd_none()];
        default:
            return [new State(FormState__startLoading(state.FormState), state.OnClose, state.SuccessCallback), Cmd_importDemoData((Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
    }
}

function DialogBody(props) {
    const t = useTranslation()[0];
    if (props.FormState.IsLoading) {
        return createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: t("demo_data_dialog.import_demo_data_wait_info"),
        });
    }
    else {
        return createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: t("demo_data_dialog.question_import"),
        });
    }
}

export function DemoDataImportDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("demo_data_dialog.import"), {
        Body: singleton(createElement(DialogBody, {
            FormState: state_1.FormState,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-demo-data-import-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                patternInput_1[1](new Msg(0, []));
            },
            TestId: "save-demo-data-import-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

